(() => {
  const container = document.querySelector('.shopify-policy__container');
  if (!container || container.querySelector('.sp-page')) return;
  const data = document.querySelector('script[data-toc-label]')?.dataset || {};
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const titleNode = container.querySelector('.shopify-policy__title h1') || container.querySelector('h1');
  const titleText = (titleNode ? titleNode.textContent : document.title).trim();
  const bodyNode = container.querySelector('.shopify-policy__body .rte') || container.querySelector('.shopify-policy__body') || container.querySelector('.rte');
  if (!bodyNode) return;

  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };

  /* Hero */
  const hero = el('header', 'sp-hero');
  const heroInner = el('div', 'sp-inner');
  heroInner.append(el('span', 'sp-hero__rule'), el('h1', '', titleText));
  const meta = el('p', 'sp-meta');
  const firstP = bodyNode.querySelector('p');
  if (firstP && /^\s*(last updated|effective)/i.test(firstP.textContent)) {
    meta.appendChild(el('span', '', firstP.textContent.trim()));
    firstP.remove();
  }
  if (data.minLabel) {
    const words = (bodyNode.textContent || '').trim().split(/\s+/).length;
    meta.appendChild(el('span', '', `${Math.max(1, Math.round(words / 220))} ${data.minLabel}`));
  }
  if (meta.children.length) heroInner.appendChild(meta);
  hero.appendChild(heroInner);

  /* Numbered sections */
  const headings = [...bodyNode.querySelectorAll('h2')];
  if (headings.length) {
    const root = headings[0].parentElement;
    const frag = document.createDocumentFragment();
    const lede = el('div', 'sp-lede');
    frag.appendChild(lede);
    let target = lede;
    let count = 0;
    [...root.childNodes].forEach((node) => {
      if (node.nodeType === 1 && node.tagName === 'H2') {
        count += 1;
        const section = el('section', 'sp-section');
        const num = el('span', 'sp-num', String(count).padStart(2, '0'));
        num.setAttribute('aria-hidden', 'true');
        const content = el('div', 'sp-content');
        section.append(num, content);
        frag.appendChild(section);
        content.appendChild(node);
        target = content;
      } else {
        target.appendChild(node);
      }
    });
    if (!lede.children.length) lede.remove();
    root.replaceChildren(frag);
  }

  /* Layout */
  const layout = el('div', 'sp-inner sp-layout');
  const body = el('div', 'sp-body');
  body.appendChild(bodyNode);

  const links = [];
  if (headings.length > 1) {
    const nav = el('nav', 'sp-toc');
    if (data.tocLabel) {
      nav.setAttribute('aria-label', data.tocLabel);
      nav.appendChild(el('p', '', data.tocLabel));
    }
    const list = el('ol');
    headings.forEach((heading, i) => {
      if (!heading.id) heading.id = `policy-${i + 1}`;
      const item = el('li');
      const link = el('a', '', heading.textContent.trim());
      link.href = `#${heading.id}`;
      item.appendChild(link);
      list.appendChild(item);
      links.push(link);
    });
    nav.appendChild(list);
    layout.append(nav, body);
    const measure = () => {
      nav.classList.toggle('is-overflow', list.scrollHeight > list.clientHeight + 2);
      nav.classList.toggle('is-end', list.scrollTop + list.clientHeight >= list.scrollHeight - 2);
    };
    list.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure);
    requestAnimationFrame(measure);
    links.forEach((link) => link.addEventListener('click', (e) => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', link.hash);
    }));
  } else {
    layout.classList.add('sp--no-toc');
    layout.appendChild(body);
  }

  const page = el('div', 'sp-page');
  page.append(hero, layout);
  if (!links.length) page.classList.add('sp--no-toc');

  /* Back to top */
  if (data.topLabel) {
    const end = el('div', 'sp-end');
    end.innerHTML = '<a href="#"><span></span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6"/></svg></a>';
    end.querySelector('span').textContent = data.topLabel;
    end.querySelector('a').addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    page.appendChild(end);
  }

  container.replaceChildren(page);

  /* Full-bleed: sit edge to edge whatever width the theme gives the policy wrapper */
  const bleed = () => {
    page.style.marginLeft = '0px';
    page.style.width = `${document.documentElement.clientWidth}px`;
    page.style.marginLeft = `${-page.getBoundingClientRect().left}px`;
  };
  bleed();
  window.addEventListener('resize', bleed);

  /* Reading progress */
  const bar = el('div', 'sp-progress');
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML = '<i></i>';
  document.body.appendChild(bar);
  const fill = bar.firstChild;
  let ticking = false;
  const update = () => {
    const rect = body.getBoundingClientRect();
    const total = rect.height - window.innerHeight * 0.5;
    fill.style.transform = `scaleX(${Math.min(Math.max((window.innerHeight * 0.3 - rect.top) / Math.max(total, 1), 0), 1)})`;
    ticking = false;
  };
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  window.addEventListener('resize', update);
  update();

  /* Active section in the table of contents */
  if (links.length && 'IntersectionObserver' in window) {
    const setActive = (id) => links.forEach((link) => {
      if (link.hash === `#${id}`) {
        link.setAttribute('aria-current', 'true');
        const list = link.closest('ol');
        if (list && list.scrollHeight > list.clientHeight && window.innerWidth > 999) {
          const top = link.offsetTop - list.clientHeight / 2 + link.offsetHeight / 2;
          list.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
        }
      } else link.removeAttribute('aria-current');
    });
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
      if (visible) setActive(visible.target.id);
    }, { rootMargin: '-120px 0px -65% 0px' });
    headings.forEach((heading) => observer.observe(heading));
  }
})();
